<template>
    <div>
        <KeepAlive>
            <SOSlotBase :loading="pageSetting.isLoadingData">
                <template v-slot:loading-page>
                    <SOLoadingPage/>
                </template>
                <template v-slot:title-bar>
                <SOTitleBar
                    page-title="Edit Konsumen"
                    type="back"
                    @back="back"
                />
                </template>
                <template v-slot:content>
                    <div class="p-x-20 p-y-16" style="">
                        <SOInputSelect
                            :required="true"
                            :title="'Terdaftar di Outlet'"
                            :selected="form.idoutlet"
                            :options="optionOutlet"
                            :placeholder="'Pilih Outlet'"
                            @option-selected="(val) => { form.idoutlet = val }"
                        />
                        
                        <div class="m-d-16"/>
                        
                        <SOInputRegular
                            :title="'Nama Konsumen'"
                            :required="true"
                            :placeholder="'Nama Konsumen'"
                            :validation="'alphanumeric'"
                            v-model="form.nama_customer"
                        />
                        <ErrorMessage
                            class="error"
                            label="Nama Konsumen"
                            :validation="$v.form.nama_customer"
                        />

                        <label class="form-label require m-t-16">
                            Jenis Kelamin
                        </label>
                        <SOInputRadioBig
                            :radio-group="jenisKelamin"
                            :radio-selected="form.jenis_kelamin"
                            @selected-radio="(val) => { form.jenis_kelamin =  val }"
                        />

                        <div class="m-d-16"></div>

                        <SOInputTelp
                            :value="form.phone"
                            :placeholder="'Nomor Telepon'"
                            :title="'Nomor Telepon'"
                            :country-code="form.country_code"
                            v-model="form.phone"
                            @country-code="(val) => form.country_code = val"
                        />
                        <div class="f-regular f-12 f-c-midgrey m-t-4">
                            Digunakan untuk mengirim nota, status order, dan penyebaran promo — semuanya secara
                            otomatis.
                        </div>
                        <ErrorMessage
                            class="error"
                            label="Nomor Telepon"
                            :validation="$v.form.phone"
                        />
                        <SOButtonExpand
                            v-if="showExpanded"
                            text="Data opsional"
                            id="optional-data"
                            ref="dataOptional"
                            @hook:mounted="onMountedDataOptional"
                        >  
                            <template v-slot:content>
                                <div style="margin-bottom:62px">
                                    <div v-if="showAlamat">
                                        <label class="f-14 f-c-midgrey" for="">Alamat</label>
                                        <div id="address" v-if="rendered">
                                            <template v-for="(alamat, index) in form.alamat_customer">
                                                <div class="address__content" :key="index">
                                                    <div class="d-flex align-items-center">
                                                        <div class="flex-1" style="overflow: hidden; white-space: nowrap;">
                                                            <div class="d-flex align-items-center" >
                                                                <div class="f-16 f-bold f-c-text-primary m-r-8" v-if="alamat.judul">
                                                                  {{ alamat.judul }}
                                                                </div>
                                                                <div
                                                                    v-if="alamat.alamat_utama && alamat.alamat_utama == '1'"
                                                                    class="f-12 f-c-midgrey p-x-4 bg-gray rounded"
                                                                >
                                                                    Alamat Utama
                                                                </div>
                                                            </div>
                                                            <div style="text-overflow: ellipsis; overflow: hidden;" class="f-16">
                                                                {{ alamat.alamat }}
                                                            </div>
                                                            <div class="f-12 f-c-midgrey">
                                                                <template v-if="alamat.longitude && alamat.latitude">
                                                                    <span><i class="fa fa-map-marker m-r-4"></i></span> Titik Lokasi Terpasang
                                                                </template>
                                                                <template v-else>
                                                                    Titik lokasi belum diatur
                                                                </template>
                                                            </div>
                                                        </div>
                                                        <div class="dropdown">
                                                            <div class="" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                <SOIconBase view-box="0 0 24 24" width="24" height="24">
                                                                    <template v-slot:icon>
                                                                        <MoreMenu2424 />
                                                                    </template>
                                                                </SOIconBase>
                                                            </div>
                                                            <div class="dropdown-menu py-0" aria-labelledby="dropdownMenuButton">
                                                                <div class="dropdown-item" @click="primaryAddress(alamat.idalamat)">
                                                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M11 2.00009C6.02944 2.00009 2 6.02953 2 11.0001C2 15.9707 6.02944 20.0001 11 20.0001C15.9706 20.0001 20 15.9707 20 11.0001C20 6.02953 15.9706 2.00009 11 2.00009ZM0 11.0001C0 4.92496 4.92487 9.15527e-05 11 9.15527e-05C17.0751 9.15527e-05 22 4.92496 22 11.0001C22 17.0752 17.0751 22.0001 11 22.0001C4.92487 22.0001 0 17.0752 0 11.0001ZM11 9.00001C9.89544 9.00001 9.00001 9.89544 9.00001 11C9.00001 12.1046 9.89544 13 11 13C12.1046 13 13 12.1046 13 11C13 9.89544 12.1046 9.00001 11 9.00001ZM7.00001 11C7.00001 8.79087 8.79087 7.00001 11 7.00001C13.2091 7.00001 15 8.79087 15 11C15 13.2091 13.2091 15 11 15C8.79087 15 7.00001 13.2091 7.00001 11Z" fill="#206CFE"/>
                                                                    </svg>
                                                                    <span class="m-l-4">Jadikan Utama</span>
                                                                </div>
                                                                <div class="separator-line"/>
                                                                <div class="dropdown-item" @click="editAlamat(alamat)">
                                                                    <SOIconBase view-box="0 0 20 21" width="20" height="21">
                                                                        <template v-slot:icon>
                                                                            <EditPencil2021 />
                                                                        </template>
                                                                    </SOIconBase>
                                                                    <span class="m-l-4">Ubah</span>
                                                                </div>
                                                                <div class="separator-line"/>
                                                                <div class="dropdown-item" @click="deleteAddress(index)">
                                                                    <SOIconBase view-box="0 0 20 20" width="20" height="20">
                                                                        <template v-slot:icon>
                                                                            <Trash2020 />
                                                                        </template>
                                                                    </SOIconBase>
                                                                    <span class="m-l-4">Hapus</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="separator-line" :key="'line' + index"></div>
                                            </template>
                                            <div class="address__content f-16 f-c-blue f-semi" @click="addAlamat()">
                                                + Tambah alamat...
                                            </div>
                                        </div>
                                        <p class="f-12 f-c-midgrey m-t-4">
                                            Digunakan jika ada pengantaran / penjemputan barang di lokasi konsumen.
                                        </p>
                                    </div>
                                    <SOInputSelect
                                        :required="true"
                                        title="Sapaan"
                                        placeholder="Sapaan"
                                        :selected="selectedSapaan"
                                        :options="sapaan.filter((a) => a.tipeSapaan === parseInt(form.jenis_kelamin) || a.tipeSapaan === 2)"
                                        @option-selected="getSapaan"
                                    />
                                    <ErrorMessage
                                        class="error"
                                        label="Sapaan"
                                        :validation="$v.form.sapaan"
                                    />
                                    
                                    <div class="m-d-16"></div>

                                    <SOInputRegular
                                        :title="'Instansi'"
                                        :placeholder="'Instansi'"
                                        :value="form.instansi"
                                        :validation="'alphanumeric'"
                                        v-model="form.instansi"
                                    />
                                    <div class="f-regular f-12 f-c-midgrey m-t-8">
                                        Jika konsumen mewakili suatu instansi
                                    </div>
                                    <ErrorMessage
                                        class="error"
                                        label="Instansi"
                                        :validation="$v.form.instansi"
                                    />

                                    <div class="m-d-16"></div>
                                    <SOInputDate
                                        :title="'Tanggal Lahir'"
                                        :placeholder="'Tanggal Lahir'"
                                        v-model="tanggalLahir"
                                        :max-date="$moment().format('YYYY-MM-DD')"
                                        :id="'tanggal-lahir'"
                                    />
                                    <div class="f-regular f-12 f-c-midgrey m-t-4">
                                        Untuk target promo: saat konsumen berulang tahun
                                    </div>
                                    <ErrorMessage
                                        class="error"
                                        label="Tanggal Lahir"
                                        :validation="$v.form.tanggal_lahir"
                                    />

                                    <div class="m-d-16"></div>
                                    
                                    <SOInputSelect
                                        :title="'Agama'"
                                        :required="true"
                                        :selected="(!form.agama) ? '' : agama[agama.findIndex((a) => a.id === form.agama )].id"
                                        :options="agama"
                                        :placeholder="'Pilih Agama'"
                                        @option-selected="getAgama"
                                    />
                                    <div class="f-regular f-12 f-c-midgrey m-t-4">
                                        Untuk target promo: perayaan hari besar agama
                                    </div>
                                    <ErrorMessage
                                        class="error"
                                        label="Agama"
                                        :validation="$v.form.agama"
                                    />

                                    <div class="m-d-16"></div>
                                    <SOInputRegular
                                        :title="'Email'"
                                        :placeholder="'Email'"
                                        :value="form.email"
                                        :validation="'email'"
                                        v-model="form.email"
                                    />
                                    <div class="f-regular f-12 f-c-midgrey m-t-4">
                                        Untuk target promo melalui email
                                    </div>
                                    <ErrorMessage
                                        class="error"
                                        label="Email"
                                        :validation="$v.form.email"
                                    />
                                </div>
                            </template>
                        </SOButtonExpand>
                        <div class="btn_action_wrapper">
                            <SOButton
                                primary
                                full
                                text="Simpan"
                                :disable="pageSetting.isUpdating"
                                :loading="pageSetting.isUpdating"
                                @action="update()"
                            />
                        </div>
                    </div>
                </template>
                <template v-slot:modal>
                    <SOModalConfirm
                        title="Hapus Alamat Konsumen"
                        body="Yakin ingin menghapus alamat ini?"
                        button-text="Ya, Hapus"
                        ref="confirmAddressDelete"
                        outline
                        :primary="false"
                    />
                </template>
            </SOSlotBase>
        </KeepAlive>
    </div>
</template>
<script>
import {minLength, required, maxLength, email} from "vuelidate/lib/validators";
import SOLoadingPage from '@/so-components/global/ui/SOLoadingPage.vue'
import SOSlotBase from '@/so-components/global/slot/SOSlotBase.vue'
import SOTitleBar from '@/so-components/global/ui/SOTitleBar.vue'
import { mapActions, mapGetters } from 'vuex'
import SOInputSelect from '@/so-components/global/input/SOInputSelect.vue'
import SOInputRegular from '@/so-components/global/input/SOInputRegular.vue'
import ErrorMessage from '@/component-items/ErrorMessage.vue'
import SOInputRadioBig from '@/so-components/global/input/SOInputRadioBig.vue';
import SOInputTelp from '@/so-components/global/input/SOInputTelp.vue';
import SOButtonExpand from '@/so-components/global/ui/SOButtonExpand.vue';
import SOIconBase from '@/so-components/global/icons/SOIconBase.vue';
import MoreMenu2424 from '@/so-components/global/icons/iconPacks/MoreMenu2424.vue';
import Trash2020 from '@/so-components/global/icons/iconPacks/Trash2020.vue';
import EditPencil2021 from '@/so-components/global/icons/iconPacks/EditPencil2021.vue';
import SOInputDate from '@/so-components/global/input/SOInputDate.vue';
import SOButton from '@/so-components/global/ui/SOButton.vue';
import SOModalConfirm from '@/so-components/global/modal/SOModalConfirm.vue';
export default {
  components: { SOLoadingPage, SOSlotBase, SOTitleBar, SOInputSelect, SOInputRegular, ErrorMessage, SOInputRadioBig, SOInputTelp, SOButtonExpand, SOIconBase, MoreMenu2424, Trash2020, EditPencil2021, SOInputDate, SOButton, SOModalConfirm },
    name: "CustomerEdit",
    props: {
        id: {
            type: String,
            required: true
        },
    },
    data() {
        return {
          pageSetting: {
            isLoadingData: false,
            isUpdating: false,
          },
          rendered: true,
          dataOptional: false,
          form: {},
          optionOutlet: [],
          useLoadData: true,
          showExpanded: true,
          showAlamat: true,
          tanggalLahir: null,
        }
    },
    validations: {
        form: {
            nama_customer: {
				required,
				minLength: minLength(2)
			},
			sapaan: {
				required,
			},
            jenis_kelamin: {
				required,
			},
            phone: {
				minLength: minLength(6),
				maxLength: maxLength(12),
			},
            instansi: {
                minLength: minLength(2)
            },
            // agama: {
            //     required,
            // },
            email: {
                email,
            },
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.useLoadData = from.name != "customerCreateNewAlamat" && from.name != "customerEditAlamat"
        })
    },
    computed: {
        ...mapGetters("customerModule", {
			customer: "getDetailCustomer",
			topFive: "getTopFive",
            alamatData: "getAlamat",
            detailCustomer2: "getDetailCustomer",
		}),
        ...mapGetters("outletModule", {
			outlets: "getOutlet",
		}),
        ...mapGetters("metaModule", {
			jenisKelamin: "getJenisKelamin",
            sapaan: "getSapaan",
			agama: "getAgama",
		}),
        selectedSapaan() {
			if (!this.form.sapaan) {
				return ''
			}
            return this.sapaan.find((a) => a.id === this.form.sapaan).id
        }
    },
    mounted() {
        if (this.useLoadData) {
            this.getData()
        } else {
            this.showExpanded = false
            this.form = this.detailCustomer2
			this.dataOptional = true
            console.log(this.sapaan);
            //delay 500ms
            setTimeout(() => {
                this.showExpanded = true
            }, 500);
        }
        this.fetchOutlet()
    },
    methods: {
        ...mapActions("customerModule", {
            updateCustomer: "updateCustomer",
        }),
        addAlamat() {
            this.$store.commit("customerModule/setDetailCustomer2", this.form)
            this.$router.push('/konsumen/alamat/create/' + this.id + '/edit')
        },
        editAlamat(alamat) {
            this.$store.commit("customerModule/setDetailCustomer2", this.form)
            this.$store.commit("customerModule/setAlamatTemp", alamat)
            this.$router.push("/konsumen/alamat/edit/" + this.id + "/" + alamat.idalamat)
        },
        getSapaan(id) {
			let index = this.sapaan.findIndex((a) => a.id === parseInt(id))
			this.form.sapaan = this.sapaan[index].id
		},
        getTanggalLahir(date) {
			this.form.tanggal_lahir = this.$moment(date).unix() * 1000
			this.form.tanggal_lahir_formated = this.$moment(date).format("DD MMM YYYY")
			this.form.tanggal_lahir_post = date
		},
        getAgama(id) {
			let index = this.agama.findIndex((a) => a.id === parseInt(id))
			this.form.agama = this.agama[index].id
		},
        back() {
            this.$router.back();
        },
        onMountedDataOptional() {
            this.$refs.dataOptional.setExpand(this.dataOptional);
        },
        async fetchOutlet() {
			const res = await this.$store.dispatch("outletModule/fetchOutletAll")
			if (res.success) {
                this.optionOutlet = this.outlets.data.map((outlet) => {
                    return {
                        id: outlet.idoutlet,
                        text: outlet.nama
                    }
                })
			} else {
				this.$toast.error(res.err)
			}
		},
        async getListAlamat() {
            const res = await this.$store.dispatch("customerModule/fetchAlamatList", this.id)
            if (res.success) {
                this.form.alamat_customer = this.alamatData.data.map(alamat => {
                    let newAlamat = {
                        ...alamat,
                        alamat: alamat.lokasi,
                        alamat_utama: alamat.tetap
                    }
                    delete newAlamat.lokasi
                    delete newAlamat.tetap
                    return newAlamat
                })
                this.$store.commit("customerModule/resetSearchAlamat")
                this.$store.commit("customerModule/resetPaginationAlamat")
                this.$store.commit("customerModule/resetAlamat")
			} else {
				this.$toast.error(res.err)
			}
        },
        async getData() {
			this.pageSetting.isLoadingData = true
			const res = await this.$store.dispatch("customerModule/fetchDetailCustomer", this.id)
			this.pageSetting.isLoadingData = false
			if (!res.success) {
				this.$toast.error(res.err)
                return
			}
            this.form = this.customer
          if (this.customer.tanggal_lahir) {
            const formatted = this.$moment.unix(this.customer.tanggal_lahir / 1000).format('YYYY-MM-DD')
            this.tanggalLahir = formatted.startsWith('-') ? null : formatted
          } else {
            this.tanggalLahir = null
          }
            this.getListAlamat()
		},
        primaryAddress(idalamat) {
            this.rendered = false
            this.form.alamat_customer.forEach((alamat, index) => {
                alamat.alamat_utama = alamat.idalamat === idalamat ? 1 : 0
            })
            this.rendered = true
        },
        async deleteAddress(alamatIndex) {
            this.$refs.confirmAddressDelete.open().then((result) => {
                if (result) {
					this.$delete(this.form.alamat_customer, alamatIndex)
					this.showAlamat = false
					this.showAlamat = true
					this.$refs.confirmAddressDelete.close()
				}
            }).catch((err) => {
                console.log(err);
				
            });
        },
        async update() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.$toast.error("Mohon isi data dengan benar")
                return
            }
            try {

              this.pageSetting.isUpdating = true
              let form = JSON.parse(JSON.stringify(this.form))
              form.tanggal_lahir = this.tanggalLahir || ""
              form.nama = form.nama_customer
              form.telepon = form.phone
              form.jenis_kelamin = parseInt(form.jenis_kelamin)
              form.alamat_customer = form.alamat_customer.map((alamat) => {
                let newAlamat = alamat
                newAlamat.alamat_utama = (alamat.alamat_utama ?? 0).toString()
                return newAlamat
              })
              const res = await this.updateCustomer(form)
              if (res.success) {
                  this.$toast.success("Berhasil mengubah data")
                  this.pageSetting.isUpdating = false
                  this.$router.back()
              } else {
                  this.$toast.error(res.err)
                  this.pageSetting.isUpdating = false
              }
            } catch (e) {
              this.$toast.error(`Gagal mengubah data (${e})`)
              this.pageSetting.isUpdating = false
            }
        },
    }
}
</script>
<style scoped>
    #address {
        border: 1px solid #C8D0DD;
        border-radius: 3px;
    }
    #address .address__content {
        padding: 12px 16px;
    }
    #address .address__content > .d-flex {
        gap: 12px;
    }
    .btn_action_wrapper {
        position: fixed;
        bottom: 64px;
        background-color: white;
        height: 80px;
    }
    .dropdown-menu .dropdown-item{
        padding: 10px 17px;
    }
</style>